import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Image, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import { options } from '../../constants/reviewRatings';
import styles from './ReviewQuestionItem.module.css';

const cx = classnames.bind(styles);

export default function ReviewQuestionItem({ item, onScoreChosen }) {
  const handleOptionClicked = (e, optionValue) => {
    if (e) { e.preventDefault(); }
    onScoreChosen(item.id, optionValue);
  };

  return (
    <React.Fragment>
      <Text>{item.question}</Text>
      <br />
      <br />
      <div className={cx('ratingOptions')}>
        {options.map(({ icon, label, value }) => (
          <React.Fragment key={value}>
            <div
              role="button"
              tabIndex="0"
              className={cx('ratingOption')}
              onClick={() => { handleOptionClicked(null, value); }}
              onKeyUp={() => { handleOptionClicked(null, value); }}
              onKeyDown={() => { handleOptionClicked(null, value); }}
            >
              <Image src={icon} className={cx('icon')} alt={label} />
              <Text as="p">
                {label}
              </Text>
            </div>
            <div className={cx('dividerContainer')}>
              <Divider vertical />
            </div>
          </React.Fragment>
        ))}
        <div className={cx('ratingOption')}>
          <Button
            link
            fluid
            onClick={(e) => { handleOptionClicked(e, 0); }}
          >
            Not Sure
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
}

ReviewQuestionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
  }).isRequired,
  onScoreChosen: PropTypes.func.isRequired,
};
